import { DateRangePicker } from "date-range-picker-mui";
import { useState } from "react";
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#32C896', 
      light: 'rgba(23, 194, 137, 0.11)', 
      dark: '#32C896', 
    }
  },
});

const CustomDateRangePicker = ({ open, setOpen, handleDateRangeChange, definedRanges, dateRange, maxDate, minDate }) => {
  const [selectedRange, setSelectedRange] = useState(dateRange);

  const handleApply = () => {
    setOpen(false);
    handleDateRangeChange(selectedRange);
  }

  const handleCancel = () => {
    setOpen(false);
  }

  return (
    <ThemeProvider theme={theme}>
      <div className="date-range-picker-container">
        <DateRangePicker
          wrapperClassName="date-range-picker-wrapper"
          open={open}
          toggle={() => setOpen(!open)}
          onChange={(range) => setSelectedRange(range)}
          definedRanges={definedRanges}
          style={{ padding: '1rem' }}
          maxDate={maxDate}
          minDate={minDate}
          initialDateRange={dateRange}
        />
        <div className="d-flex justify-content-end mt-2" style={{ padding: '0.8rem', position: "relative" }}>
          <div style={{ position: 'absolute', top: "-8px", left: 0, right: 0, bottom: 0, backgroundColor: 'white', zIndex: 1 }}></div>
          <button className="btn date-range-picker-cancel-btn me-2" style={{ zIndex: 5 }} onClick={handleCancel}>Cancel</button>
          <button className="btn date-range-picker-apply-btn" style={{ zIndex: 5 }} onClick={handleApply}>Apply</button>
        </div>
      </div>
    </ThemeProvider>
  )
}
export default CustomDateRangePicker
